export default __webpack_public_path__ + "92fb0d7c1644c6c2f7525e71d714b19d.obj";